<template>
  <div class="p-4 bg-white">
    <div>
      <!-- <pre>
      {{ selectedEmail }}
    </pre> -->
      <div
        class="space-y-[-3px] text-sm grid gap-4 grid-cols-[50px,1fr] border-b border-solid border-gray-500"
      >
        <div>
          To:
        </div>
        <div>
          {{ selectedEmail.email_address }}
        </div>
        <div>
          Subject:
        </div>
        <div>
          {{ selectedEmail.subject }}
        </div>
        <div>
          Date:
        </div>
        <div>
          {{ moment(selectedEmail.reg_date) }}
        </div>
      </div>
      <div v-html="theMessage" class="p-2"></div>
    </div>
    <!-- attachments list  -->
    <div class=" border-t border-solid border-gray-500 sm:flex pt-2">
      <div
        v-for="(item, i) in attachments"
        :key="i"
        class="bg-gray-100 rounded-b-md p-2 mx-1"
      >
        {{ item.originalname }}
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      theMessage: null,
      attachments: [],
    };
  },
  watch: {
    selectedEmail: {
      async handler(e) {
        this.theMessage = e.email_content;
        await this.getEmailAttachments(e.id);
      },
      immediate: true,
    },
  },
  props: ["selectedEmail"],
  methods: {
    moment(d) {
      return moment(d).format("LLL");
    },
    async getEmailAttachments(id) {
      let data = {
        id: id,
      };
      let res = await axios.post("/email/anonymous", data);
      this.attachments = res.data;
    },
  },
};
</script>
